import type { OutfitPlacement } from '../../shared/outfits';

export function clampLayoutValue(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

export function createPlacement(garmentId: string, index: number): OutfitPlacement {
  const offset = ((index % 5) - 2) * 0.035;
  return {
    garmentId,
    layer: index,
    x: clampLayoutValue(0.5 + offset, 0.08, 0.92),
    y: clampLayoutValue(0.5 + offset, 0.08, 0.92),
    scale: 1,
    rotation: 0,
  };
}

export function movePlacement(
  placement: OutfitPlacement,
  horizontal: number,
  vertical: number,
): OutfitPlacement {
  return {
    ...placement,
    x: clampLayoutValue(placement.x + horizontal, 0, 1),
    y: clampLayoutValue(placement.y + vertical, 0, 1),
  };
}

export function normalizeLayers(placements: OutfitPlacement[]): OutfitPlacement[] {
  return [...placements]
    .sort((left, right) => left.layer - right.layer)
    .map((placement, layer) => ({ ...placement, layer }));
}
